import { render, staticRenderFns } from "./ValidationDocuments.vue?vue&type=template&id=0ab8ccd2&scoped=true&"
import script from "./ValidationDocuments.vue?vue&type=script&lang=js&"
export * from "./ValidationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ValidationDocuments.vue?vue&type=style&index=0&id=0ab8ccd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8ccd2",
  null
  
)

export default component.exports